
<div style="text-align: center;">
    <p-progressSpinner [ngClass]="{'center': center}" [style]="{width: size_, height: size_}"></p-progressSpinner>
</div>